import { render, staticRenderFns } from "./PreviewSecurity.vue?vue&type=template&id=54a5f131&scoped=true"
import script from "./PreviewSecurity.vue?vue&type=script&lang=js"
export * from "./PreviewSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5f131",
  null
  
)

export default component.exports